<div class="app-dialog ups-shop-rates-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ "printCardOrders.shopRates.title" | translate }}</h2>
      <p class="app-dialog__subtitle" *ngIf="result">
        {{ "printCardOrders.shopRates.subtitle" | translate }}
      </p>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body ups-shop-rates-dialog__body">
    <div class="ups-shop-rates-dialog__meta" *ngIf="result">
      <div>
        <span class="ups-shop-rates-dialog__meta-label">{{
          "printCardOrders.shopRates.shipFrom" | translate
        }}</span>
        <strong
          >{{ result.shipFrom.city }}, {{ result.shipFrom.postalCode }}
          {{ result.shipFrom.country }}</strong
        >
      </div>
      <div>
        <span class="ups-shop-rates-dialog__meta-label">{{
          "printCardOrders.shopRates.shipTo" | translate
        }}</span>
        <strong
          >{{ result.shipTo.city }}, {{ result.shipTo.postalCode }}
          {{ result.shipTo.country }}</strong
        >
      </div>
      <div>
        <span class="ups-shop-rates-dialog__meta-label">{{
          "printCardOrders.shopRates.pickupDate" | translate
        }}</span>
        <strong>{{ formatUpsDateTime(result.pickupDate) }}</strong>
      </div>
      <div>
        <span class="ups-shop-rates-dialog__meta-label">{{
          "printCardOrders.shopRates.billedWeight" | translate
        }}</span>
        <strong>{{ formatAmount(result.totalWeight) }} {{ result.weightUnit }}</strong>
      </div>
    </div>

    <div class="ups-shop-rates-dialog__weight">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ "printCardOrders.shopRates.packageWeight" | translate }}</mat-label>
        <input
          matInput
          type="number"
          step="0.01"
          min="0.01"
          [(ngModel)]="packageWeight"
          [disabled]="loading"
        />
        <span matSuffix>{{ weightUnit }}</span>
      </mat-form-field>
      <button
        mat-stroked-button
        type="button"
        color="primary"
        (click)="fetchRates()"
        [disabled]="loading"
      >
        <mat-spinner class="dc-btn-spinner" diameter="18" *ngIf="loading"></mat-spinner>
        {{ "printCardOrders.shopRates.refresh" | translate }}
      </button>
    </div>

    <div class="ups-shop-rates-dialog__loading" *ngIf="loading && !result">
      <mat-spinner diameter="32"></mat-spinner>
    </div>

    <p class="ups-shop-rates-dialog__empty" *ngIf="!loading && result && quotes.length === 0">
      {{ "printCardOrders.shopRates.empty" | translate }}
    </p>

    <div
      class="ups-shop-rates-dialog__table-wrap"
      [class.ups-shop-rates-dialog__table-wrap--loading]="loading"
      *ngIf="quotes.length > 0"
    >
      <table class="ups-shop-rates-dialog__table">
        <thead>
          <tr>
            <th>{{ "printCardOrders.shopRates.service" | translate }}</th>
            <th>{{ "printCardOrders.shopRates.transit" | translate }}</th>
            <th>{{ "printCardOrders.shopRates.cost" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let quote of quotes">
            <td>
              <div class="ups-shop-rates-dialog__service">
                <strong *ngIf="quote.serviceDescription?.trim()">{{ quote.serviceDescription }}</strong>
                <strong *ngIf="!quote.serviceDescription?.trim()">{{
                  ("printCardOrders.ups.service." + quote.serviceCode) | translate
                }}</strong>
                <span class="ups-shop-rates-dialog__code">{{ quote.serviceCode }}</span>
                <span class="ups-shop-rates-dialog__badge" *ngIf="quote.guaranteed === true">{{
                  "printCardOrders.shopRates.guaranteed" | translate
                }}</span>
                <span
                  class="ups-shop-rates-dialog__badge ups-shop-rates-dialog__badge--muted"
                  *ngIf="quote.guaranteed === false"
                  >{{ "printCardOrders.shopRates.notGuaranteed" | translate }}</span
                >
              </div>
            </td>
            <td>
              <ng-container
                *ngIf="
                  quote.businessDaysInTransit?.trim() || quote.deliveryDate?.trim();
                  else noTransit
                "
              >
                <span *ngIf="quote.businessDaysInTransit">
                  {{
                    "printCardOrders.shopRates.businessDays"
                      | translate : { days: quote.businessDaysInTransit }
                  }}
                </span>
                <span class="ups-shop-rates-dialog__delivery" *ngIf="quote.deliveryDate">
                  {{ "printCardOrders.shopRates.deliveredBy" | translate }}
                  {{ formatUpsDateTime(quote.deliveryDate, quote.deliveryTime) }}
                </span>
              </ng-container>
              <ng-template #noTransit>—</ng-template>
            </td>
            <td class="ups-shop-rates-dialog__cost">
              <strong>{{ formatAmount(quote.totalCharges) }} {{ quote.currencyCode }}</strong>
              <span *ngIf="quote.transportationCharges">
                {{ "printCardOrders.shipment.transportationCharges" | translate }}:
                {{ formatAmount(quote.transportationCharges) }} {{ quote.currencyCode }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()">
      {{ "close" | translate }}
    </button>
  </footer>
</div>
